import { ReactElement } from 'react';

import { Completed } from '@app/components/Company/Inquiry/Completed';
import { HeadBlock } from '@app/components/Shared/HeadBlock';

export function CompletedPage(): ReactElement {
  return (
    <>
      <HeadBlock />
      <Completed />
    </>
  );
}
